import type {Language} from "@project/sdk/engineering";
import {useMutation} from "@tanstack/react-query";

import {editMaterialDescriptionMutationOptions} from "./edit-material-description.mutation-options";

export function useEditMaterialDescription(id: string, language: Language) {
  return useMutation(editMaterialDescriptionMutationOptions(id, language));
}
